import React from "react";
import { Navigate } from "react-router-dom";
import { useSubscription } from "./useSubscription";

const ProtectedRoute1 = ({ children }) => {
    const { isLoading, isGrowth } = useSubscription();

    if (isLoading) {
        return <div className="text-center mt-4">Loading...</div>;
    }

    if (!isGrowth) {
        return <Navigate to="/seller/subscription" replace />;
    }

    return children;
};

export default ProtectedRoute1;